import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { VrrLink } from '../shared_components';
import URLS from '../routing/urls';
import './Footer.scss';

const Footer: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="footer">
      <Trans
        t={t}
        i18nKey="footer.links"
        components={{
          link1: <VrrLink title="terms" link={URLS.TERMS} />,
          link2: <VrrLink title="privacy" link={URLS.PRIVACY} />,
          link3: <VrrLink title="cookies" link={URLS.COOKIES} />
        }}
      />
    </div>
  );
};

export default Footer;
